import { render, staticRenderFns } from "./WithdrawApproveModal.vue?vue&type=template&id=c0c9a7d4&scoped=true&"
import script from "./WithdrawApproveModal.vue?vue&type=script&lang=js&"
export * from "./WithdrawApproveModal.vue?vue&type=script&lang=js&"
import style0 from "./WithdrawApproveModal.vue?vue&type=style&index=0&id=c0c9a7d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0c9a7d4",
  null
  
)

export default component.exports